import { WebSocketGlobalState } from "./websocket";

/**
 * Handles a ping message that is received from the server
 * The ping message is used to keep the websocket connection alive
 */
export const handlePing = async () => {
  WebSocketGlobalState.setPing();
};
